$(document).ready(function(){
    $('#closePopup').click(function(){
        $('#popup').fadeOut();
        var popupValue = 'true';
        var expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (7 * 60 * 1000));
        document.cookie = 'popup=' + popupValue + '; expires=' + expirationDate.toUTCString() + '; path=/';
    });
});